import React from "react";

export const NullableValue = ({ value, fallback = "—", children }) => {
    if (value === null || value === undefined || value === "") {
        return <div>{fallback}</div>;
    }

    if (!children){
        return <div>{value}</div>;
    }

    return children;
};

export default NullableValue;
